export const LANG_TO_METADATA_TYPE: Record<string, string> = {
  apex: "ApexClass",
  apexclass: "ApexClass",
  apextest: "ApexClass",
  test: "ApexClass",
  trigger: "ApexTrigger",
  apextrigger: "ApexTrigger",
  java: "ApexClass",
  xml: "CustomObject",
  html: "LightningComponentBundle",
  javascript: "LightningComponentBundle",
  typescript: "LightningComponentBundle",
  jsx: "LightningComponentBundle",
  tsx: "LightningComponentBundle",
  react: "LightningComponentBundle",
  css: "LightningComponentBundle",
  json: "CustomObject",
  soql: "ApexClass",
  visualforce: "ApexPage",
  aura: "AuraDefinitionBundle",
  lwc: "LightningComponentBundle",
};

export interface DevAgentSession {
  id: number;
  uuid: string;
  user_id: string;
  org_id?: string;
  title: string;
  status: string;
  metadata: Record<string, any>;
}

export interface MCPTool {
  name: string;
  description?: string;
  server?: string;
}

export interface UploadResult {
  id: string;
  name: string;
  url?: string;
  filename?: string;
  file_type?: string;
  lines?: number;
  full_content?: string;
}

export interface DependencyItem {
  name: string;
  id: string;
  metadata_type: string;
}

export interface DependencySnapshot {
  target: string;
  target_id?: string | null;
  callers: DependencyItem[];
  tests: DependencyItem[];
  total: number;
  status: "ready" | "awaiting_user_scope" | "approved" | "rejected" | "applied";
  captured_at: string;
}

export interface DevAgentSessionState {
  impact_analysis?: any;
  test_coverage?: any;
  test_runs?: any[];
  summary?: any;
  cost?: any;
  artifacts?: any[];
  active_plan?: {
    subtasks?: any[];
    summary?: string;
    status?: string;
  } | null;
  dismissed_panels?: string[];
  dependencies?: DependencySnapshot | DependencySnapshot[] | null;
}

export interface MetadataItem {
  id: string;
  full_name: string;
  name?: string;
  file_name?: string;
  metadata_type: string;
  content?: string;
  status?: string;
  last_modified_date?: string;
  last_modified_by?: string;
  language?: string;
}

export interface ImpactCaller {
  name: string;
  type: string;
  risk: "high" | "medium" | "low";
}

export interface ImpactReference {
  file: string;
  line: number;
  kind: "CALLS" | "EXTENDS" | "IMPLEMENTS";
}

export interface ImpactAnalysisResult {
  blast_radius: number;
  callers: ImpactCaller[];
  callees: { name: string; type: string }[];
  data_access: { object: string; operations: string[] }[];
  triggers_at_risk: { trigger: string; object: string }[];
  references: ImpactReference[];
  summary: string;
}

export interface TestClassCoverage {
  name: string;
  coverage_pct: number | null;
  lines_covered: number | null;
  lines_uncovered: number | null;
}

export interface TestCoverageResult {
  test_classes: TestClassCoverage[];
  aggregate_coverage_pct: number | null;
  summary: string;
}

export interface PostSaveAnalysisResult {
  impact: ImpactAnalysisResult | null;
  coverage: TestCoverageResult | null;
  dependencies?: DependencySnapshot | null;
  class_name: string;
  metadata_type: string;
  timestamp: string;
  elapsed_ms: number;
}
